import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

function Portal({ selector, children, time = 5000 }) {
  const [placeholder, setPlaceholder] = useState(null);

  useEffect(() => {
    const INTERVAL = 300;
    const attempts = time / INTERVAL;

    let count = 0;

    const timerId = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        setPlaceholder(element);
        clearInterval(timerId);
        return;
      }

      if (count > attempts) {
        clearInterval(timerId);
        return;
      }

      count += 1;
    }, INTERVAL);

    return () => clearInterval(timerId);
  }, []);

  if (!placeholder || !children) {
    return null;
  }

  const childrenWithProps = React.Children.map(children, child => (
    React.cloneElement(child, { ...child.props, placeholder })
  ));

  return ReactDOM.createPortal(childrenWithProps, placeholder);
}

export default (props) => <ComponentErrorBoundary><Portal {...props} /></ComponentErrorBoundary>;
